import * as yup from 'yup';

function makeAllFieldsOptional(schema: yup.AnySchema): yup.AnySchema {
  if (schema instanceof yup.ObjectSchema) {
    const shape = schema.fields;
    const newShape: Record<string, yup.AnySchema> = {};
    for (const key in shape) {
      newShape[key] = makeAllFieldsOptional(shape[key] as yup.AnySchema);
    }
    return yup.object().shape(newShape);
  }

  if ('innerType' in schema && schema.innerType) {
    // handle arrays of nested schemas
    return schema.notRequired();
  }

  return schema.notRequired();
}

export default makeAllFieldsOptional;
